// src/hooks/useIsAdmin.ts
// Thin wrapper over the session roles context (#13).
import { useRoles } from './roles/RolesContext';
import { selectIsAdmin } from './roles/deriveRoles';

interface UseIsAdminResult {
  isAdmin: boolean;
  loading: boolean;
}

export function useIsAdmin(): UseIsAdminResult {
  const roles = useRoles();
  return { ...selectIsAdmin(roles), loading: roles.loading };
}

export default useIsAdmin;
